module.exports = __webpack_public_path__ + "static/huggingface-ba674beba14628f033f29d80bcdaff93.svg";